<!--최종순위-->
<style scoped lang="scss">
    .result-ranking-list-wrap{
        .tournament-title{
            text-align: center;
            >div{
                width: 100%;
                overflow: hidden;

                >p{
                    float: left;
                    /*display: table-cell;*/
                    word-break: break-all;
                }
                .title{
                    width: fit-content;
                    max-width: calc(100% - 80px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 1;	//원하는 라인수
                    -webkit-box-orient: vertical;
                    line-height: 50px;
                    display: -webkit-box;
                    white-space: normal;
                    overflow: hidden;
                    height: 50px;
                }
                .level{
                    width: 80px;
                }
            }
        }
    }
    span{
    }
</style>
<template>
    <div class="result-ranking-list-wrap">
        <div class="tournament-title">
            <div>
                <p class="title">{{tournament.tnmtName}}</p>
                <p class="level">({{result.eventId!=="UNKNOWN" ? result.eventName : null}} {{result.age}}  {{result.level}})</p></div>
            </div>

        <div class="table-wrap">

        <table class="participation-table">
            <tr v-for="(participant) in result.participantList">
                <td class="icon" width="40">
                    <div :style="{backgroundImage: `url('${require('@/image/icon/img-medal-gold.svg')}')`}" v-if="participant.ranking===1">
                        <span>{{participant.ranking}}</span>
                    </div>
                    <div :style="{backgroundImage: `url('${require('@/image/icon/img-medal-silver.svg')}')`}" v-else-if="participant.ranking===2">
                        <span>{{participant.ranking}}</span>
                    </div>
                    <div :style="{backgroundImage: `url('${require('@/image/icon/img-medal-bronze.svg')}')`}" v-else-if="participant.ranking===3">
                        <span>{{participant.ranking}}</span>
                    </div>
                </td>
                <td class="info">
                    <div>
                        <p class="participant-name">{{participant.participantName}}</p>
                        <p class="user-name">
                            <span v-for="user in participant.userList">{{user.playerName}}</span>
                        </p>
                    </div>

                </td>
                <td class="detail-btn" width="75" @click="$router.push(`${$route.path}/${participant.participantId}`)"><p>경기기록</p></td>
            </tr>
        </table>
            <EmptyContent v-if="result.participantList.length===0" style="height: calc(100vh - 102px)" content="최종순위 정보가 없습니다"></EmptyContent>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";
    export default{
        components: {EmptyContent},
        computed: {
            ...mapState('tournaments', ['result', 'tournament'])
        },
        created(){
            for(let i of this.result.participantList){
                for(let j of this.result.participantList){
                    if(i.ranking>j.ranking){
                        const tmp = i
                        i = j
                        j = tmp
                    }
                }
            }
        }
    }
</script>
